import { render, staticRenderFns } from "./B737.vue?vue&type=template&id=113ed724&scoped=true&"
import script from "./B737.vue?vue&type=script&lang=js&"
export * from "./B737.vue?vue&type=script&lang=js&"
import style0 from "./B737.vue?vue&type=style&index=0&id=113ed724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113ed724",
  null
  
)

export default component.exports